/**
 * TimelineControls Component
 *
 * Controls for view mode selection and strain filtering in the Sales Timeline.
 * Provides tabs for switching between 7-day, 14-day, and month views,
 * plus a dropdown for filtering by strain.
 *
 * US-PE-006: Sales Timeline - Phase 3 Page Components
 */

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'

/**
 * View mode configuration
 */
const VIEW_MODES = [
  { value: '7d', label: '7 Days' },
  { value: '14d', label: '14 Days' },
  { value: 'month', label: 'Month' }
]

/**
 * TimelineControls - View mode tabs and strain filter
 *
 * @param {Object} props
 * @param {string} props.viewMode - Current view mode ('7d' | '14d' | 'month')
 * @param {Function} props.onViewModeChange - Callback when view mode changes
 * @param {string|null} props.selectedStrainId - Selected strain ID (null for all strains)
 * @param {Function} props.onStrainChange - Callback when strain selection changes
 * @param {Array} props.strains - Array of strain objects { id, name }
 * @param {string} [props.className] - Additional CSS classes
 */
export default function TimelineControls({
  viewMode = '7d',
  onViewModeChange,
  selectedStrainId = null,
  onStrainChange,
  strains = [],
  className = ''
}) {
  return (
    <div className={`flex flex-wrap items-center justify-between gap-4 ${className}`}>
      {/* View Mode Tabs */}
      <Tabs
        value={viewMode}
        onValueChange={onViewModeChange}
      >
        <TabsList>
          {VIEW_MODES.map((mode) => (
            <TabsTrigger
              key={mode.value}
              value={mode.value}
            >
              {mode.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      {/* Strain Filter Dropdown */}
      <Select
        value={selectedStrainId || 'all'}
        onValueChange={(value) => onStrainChange(value === 'all' ? null : value)}
      >
        <SelectTrigger className="w-44">
          <SelectValue placeholder="Select strain" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Strains</SelectItem>
          {strains.map((strain) => (
            <SelectItem key={strain.id} value={strain.id}>
              {strain.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
